import type {IRouteService, ViewModeType} from './IRouteService';

export class BaseRouteService implements IRouteService {
  protected enableGoHome: boolean;
  protected mode: ViewModeType;
  protected parameters: {[key: string]: any};

  constructor(
    enableGoHome: boolean,
    mode: ViewModeType,
    parameters: {[key: string]: any}
  ) {
    this.enableGoHome = enableGoHome;
    this.mode = mode;
    this.parameters = parameters;
  }

  isGoHomeEnabled(): boolean {
    return this.enableGoHome;
  }

  setParameter(key: string, value: any): void {
    this.parameters[key] = value;
  }

  getParameter(key: string): any {
    return this.parameters[key];
  }

  // Abstract methods to be implemented by subclasses
  getCreateRoute(): string {
    throw new Error('Method not implemented.');
  }

  getEditRoute(_id: string | number): string {
    throw new Error('Method not implemented.');
  }

  getViewRoute(_id: string | number): string {
    throw new Error('Method not implemented.');
  }

  getGoBackRoute(_id?: string | number): string {
    throw new Error('Method not implemented.');
  }

  getGoHomeRoute(): string {
    throw new Error('Method not implemented.');
  }
}
